import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "../../utils/leafletSetup";
import "./routeMap.css";

// Distinct pulsing marker for the driver's live position.
const liveCarIcon = L.divIcon({
  className: "sr__live-marker",
  html: '<span class="sr__live-marker-pulse"></span><span class="sr__live-marker-dot">🚗</span>',
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

function FitBounds({ departureCoords, arrivalCoords }) {
  const map = useMap();

  useEffect(() => {
    if (departureCoords && arrivalCoords) {
      const bounds = [
        [departureCoords.lat, departureCoords.lng],
        [arrivalCoords.lat, arrivalCoords.lng],
      ];
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [map, departureCoords, arrivalCoords]);

  return null;
}

const RouteMap = ({ departureCoords, arrivalCoords, departureName, arrivalName, liveLocation }) => {
  if (!departureCoords || !arrivalCoords || !departureCoords.lat || !arrivalCoords.lat) {
    return null;
  }

  const depPos = [departureCoords.lat, departureCoords.lng];
  const arrPos = [arrivalCoords.lat, arrivalCoords.lng];
  const hasLive = liveLocation && Number.isFinite(liveLocation.lat) && Number.isFinite(liveLocation.lng);

  return (
    <div className="sr__route-map">
      <MapContainer
        center={depPos}
        zoom={6}
        className="sr__route-map__container"
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds departureCoords={departureCoords} arrivalCoords={arrivalCoords} />
        <Marker position={depPos}>
          <Popup>{departureName || "Departure"}</Popup>
        </Marker>
        <Marker position={arrPos}>
          <Popup>{arrivalName || "Arrival"}</Popup>
        </Marker>
        <Polyline
          positions={[depPos, arrPos]}
          pathOptions={{ color: "#FF4820", weight: 3, dashArray: "10, 6" }}
        />
        {hasLive && (
          <Marker position={[liveLocation.lat, liveLocation.lng]} icon={liveCarIcon}>
            <Popup>Driver's live location</Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
};

export default RouteMap;
